import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBuitenRotterdam = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      d="M8.7 18.48a8.41 8.41 0 0 1 11.93 0A5.3 5.3 0 0 0 23 19.9V9H7v10.68a7.3 7.3 0 0 0 1.7-1.2"
    />
    <path
      fill="#F8BADD"
      d="M18 21.52a4.48 4.48 0 0 0-6.73 0A8.83 8.83 0 0 1 7 23.83V31h16v-7.06a8.53 8.53 0 0 1-5-2.42"
    />
    <path
      fill="#F170B8"
      d="M21 12.5a6.5 6.5 0 1 1 13 0c0 3.59-6.5 12.35-6.5 12.35S21 16.09 21 12.5"
    />
    <path
      fill="#F8BADD"
      d="M27.5 15.85a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M29.167 10.006A3 3 0 0 0 27.5 9.5v-1a4 4 0 1 1-4 4h1a3 3 0 1 0 4.667-2.494M20.5 32.58V25h1v8.58h-5.58v-1z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBuitenRotterdam);

export default ForwardRef;
